import Vue from 'vue'
import i18n from './i18n'
import router from "./router"
import custom from "@/plugins/Custom";

import App from './App.vue'
import vuetify from './plugins/vuetify';
import Custom from "@/plugins/Custom";
import SideBar from "@/views/SideBar.vue";
// import colors from 'vuetify/lib/util/colors'

Vue.config.productionTip = false

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    //handle meta tags, SEO
    Custom.setMetaAndTitle(to)
  });
});

Vue.component('side-bar', SideBar);
new Vue({
  vuetify,
  i18n,
  router,
  custom, //todo: wofür ist das gut? brauchen wir es wirklich?
  render: h => h(App)
}).$mount('#app')

Vue.use(vuetify)
